import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PrecastPrintTableComponent } from './precast-print-table/precast-print-table.component';

const routes: Routes = [
  {
    path: '',
    component : PrecastPrintTableComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PrecastPrintRoutingModule { }
